<template>
  <div class="content">
    <h3>Deals dashboard</h3>
    <form class="filter-form" v-if="showFilters">
      <div class="form-row">
        <div
          class="form-group col-md-2"
          v-bind:class="{ 'col-lg-3': filterLabels[filter]==='Financial company (alias)', 'col-md-4': filterLabels[filter]==='Financial company (alias)'}"
          v-for="(value, filter) in filters" v-bind:key="filter">
          <label>{{ filterLabels[filter] }}</label>
          <div v-if="DDL[filter]">
            <v-select
              label="name"
              key="id"
              :options="DDL[filter]"
              v-model="filters[filter]"
              :reduce="option => option.id"
              :multiple="true"
              :clearSearchOnSelect="true"
              :closeOnSelect="false"
              :clearable="true"
            ></v-select>
          </div>
          <div v-else>
            <b-input v-if="filter.indexOf('date_') === 0" type="date" v-model="filters[filter]"/>
            <b-input v-else type="text" v-model="filters[filter]"/>
          </div>
        </div>
      </div>
      <div class="btn-group">
        <div class="btn-group mr-2">
          <b-button @click="filter" variant="primary" type="button">Filter</b-button>
        </div>
        <div class="btn-group mr-2">
          <b-button @click="resetFilter" variant="warning" type="button">Reset filter</b-button>
        </div>
      </div>
    </form>
    <p style="font-size: 12px; margin-bottom: 0; text-align: end;">Last updated {{ lastUpdateAt }}</p>

    <div class="form-row" v-if="!showFilters">
      <button class="btn btn-info" @click="showFilters = true">Show filters</button>
    </div>

    <div class="table-container">
      <div v-if="loading" style="text-align: center">
        <b-spinner style="text-align: center" variant="primary" label="Loading..."></b-spinner>
      </div>
      <b-table
        v-else
        class="table-scroll"
        :items="data"
        :fields="tableFields"
        striped
        no-local-sorting
        @sort-changed="sort"
      >
        <template v-slot:cell(external_account)="row">
          {{ row.item.external_account ? row.item.external_account.alias : 'NOT FOUND!' }}
          {{ row.item.external_account ? '(id: ' + row.item.external_account.id + ')' : '' }}
        </template>
        <template v-slot:cell(status)="row">
          {{ row.item.status.name }}
        </template>
        <template v-slot:cell(weekend)="row">
          {{ row.item.weekend ? 'Excluded' : 'Not excluded' }}
        </template>
        <template v-slot:cell(lastInvoicePeriod)="row">
          {{ row.item.lastPeriodInfo.info }}
        </template>
        <template v-slot:cell(actions)="row">
          <div class="btn-group">
            <div class="btn-group mr-2"
                :class="{'disabled': !row.item.periodsExist}">
              <router-link class="btn btn-info btn-sm"
                          :disabled="!row.item.periodsExist"
                          :class="{'disabled': !row.item.periodsExist}"
                          :to="{ path: `/billing/${row.item.id}`}">
                Billing
              </router-link>
            </div>

            <div class="btn-group mr-2">
              <button class="btn btn-warning btn-sm" @click="createPeriod(row.item.id, row.item.name, row.item.lastPeriodInfo)">Create period
              </button>
            </div>

            <div class="btn-group mr-2">
              <button class="btn btn-danger btn-sm" @click="closeDeal(row.item.id)">Close</button>
            </div>

          </div>
        </template>
      </b-table>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      class="mt-4"/>
    <b-select class="col-md-2" id="per-page-input" v-model="perPage" :options="perPageConfig"/>

    <b-modal ref="closeModalRef" hide-footer title="Close deal">
      <div class="d-block text-center">
        <h3>Close this deal?</h3>
      </div>
      <b-button class="mt-3" variant="danger" block @click="doClose">Close</b-button>
      <b-button class="mt-3" variant="warning" block @click="hideModal('closeModalRef')">Cancel</b-button>
    </b-modal>


    <b-modal ref="createInvoicePeriodRef" hide-footer>
      <template #modal-title>
        <b>Create invoice period</b>
      </template>

      <div class="d-block text-center">
        You are creating new invoice period for deal <strong>"{{ createPeriodDealName }}"</strong>
      </div>

      <div class="period-hint">
        The previous period from <b>{{lastPeriodInfo.from }}</b> to <b>{{ lastPeriodInfo.to }}</b>
      </div>

      <div class="row">
        <div class="col-md-6 text-center">
          <date-picker v-model="createPeriodFrom" valueType="format" placeholder="Create deal from"></date-picker>
        </div>
        <div class="col-md-6 text-center">
          <date-picker v-model="createPeriodTo" valueType="format" placeholder="Create deal to"></date-picker>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6"><b-button class="mt-3" variant="warning" block @click="hideModal('createInvoicePeriodRef')">Cancel</b-button></div>
        <div class="col-md-6"><b-button class="mt-3" variant="danger" block @click="doCreatePeriod">Create</b-button></div>
      </div>
    </b-modal>

  </div>
</template>

<style lang="scss" scoped>
  /deep/ .modal-title {
    font-size: 20px;
  }
  /deep/ .period-hint {
    color: #757575;
    margin: 6px 0 10px;
    font-size: 14px;
  }
  /deep/ .vs__dropdown-option--selected {
    display: none;
  }
  /deep/ .table tr td {
    vertical-align: middle;
  }
  .btn-group {
    &.disabled:hover {
      cursor: not-allowed;
    }
    .btn.disabled {
      color: grey;
    }
  }

  .filter-form {

  }
</style>

<script>
import API from '../api/Api'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {
    vSelect,
    DatePicker
  },
  data: () => ({
    loading: false,
    lastUpdateAt: '...',
    lastUpdatedDate: new Date(),
    data: [],
    tableFields: [
      {
        key: 'name',
        sortable: false,
        label: 'Name',
      },
      {
        key: 'external_account',
        sortable: false,
        label: 'Financial company (alias)',
      },
      {
        key: 'status',
        sortable: false,
        label: 'Status'
      },
      {
        key: 'weekend',
        sortable: false,
        label: 'Weekend',
      },
      {
        key: 'lastInvoicePeriod',
        sortable: false,
        label: 'Last invoice period'
      },
      {
        key: 'actions',
        sortable: false,
        label: 'Actions'
      },
    ],
    //
    // table_from: null,
    // table_to: null,

    currentPage: 1,
    perPage: Number(window.localStorage.getItem('per-page')) || 10,
    totalRows: 0,
    perPageConfig: [
      {value: 10, text: "Per page: 10"},
      {value: 20, text: "Per page: 20"},
      {value: 30, text: "Per page: 30"},
      {value: 50, text: "Per page: 50"},
      {value: 100, text: "Per page: 100"},
    ],

    showFilters: true,
    filters: {
      name: null,
      country_iso: null,
      external_account: null,
      // status: [1],
    },

    filterLabels: {
      name: 'Deal name',
      country_iso: 'Country',
      status: 'Status',
      external_account: 'Financial company (alias)'
    },

    DDL: {},

    sortTable: {
      id: -1
    },

    closeDealId: null,
    createPeriodDealId: null,
    createPeriodDealName: null,
    createPeriodFrom: null,
    createPeriodTo: null,
    lastPeriodInfo: {from: null, to: null}
  }),

  watch: {
    currentPage: function () {
      this.loadData();
    },

    perPage: function () {
      window.localStorage.setItem('per-page', this.perPage.toString());
      this.loadData();
    }
  },

  mounted: function () {
    this.loadData();
    this.loadDDL();
    setInterval(() => {
      const lastUpdatedInterval = Math.floor(new Date() / 1000) - Math.floor(this.lastUpdatedDate / 1000);
      if (lastUpdatedInterval === 0) {
        this.lastUpdateAt = 'just now';
      }

      if (lastUpdatedInterval > 60) {
        this.lastUpdateAt = `${Math.floor(lastUpdatedInterval / 60)} minutes ago`
      } else {
        this.lastUpdateAt = `${lastUpdatedInterval} seconds ago`;
      }
    }, 3000);
    setInterval(() => this.loadData(), 1000 * 60 * 5);
  },
  methods: {
    sort: function (ctx) {
      this.sortTable = {};
      this.sortTable[ctx.sortBy] = ctx.sortDesc ? -1 : 1;
      this.currentPage = 1;

      this.loadData();
    },

    loadDDL() {
      API.get('/distribution/deals/statuses').then(data => this.DDL['status'] = data.data);
      API.get('/distribution/deals/countries').then(data => this.DDL['country_iso'] = data.data);
      API.get('/billing/dropdown/external-accounts').then(data => this.DDL['external_account'] = data.data.map(item => {
        return {
          id: item['key'],
          name: item['alias']
        }
      }));
      API.get('/distribution/deals/brokers').then(data => this.DDL['broker'] = data.data.map(broker => {
        broker.name = `(${broker.id})  ${broker.name}`;
        return broker
      }));
    },

    filter: function () {
      this.currentPage = 1;
      this.loadData();
    },

    resetFilter: function () {
      for (const field in this.filters) {
        this.filters[field] = null;
      }

      this.loadData();
    },

    loadData: function () {
      this.loading = true;
      API.post(`/distribution/deals/statistics?page=${this.currentPage}&per-page=${this.perPage}`, {
        ...this.filters,
        status: [1]
      }).then(data => {
        this.data = data.data;
        this.lastUpdatedDate = new Date();
        this.totalRows = Number(data.headers['x-pagination-total-count']) || 0;
      }).catch(e => {
        this.error = e.message
      })
        .finally(() => {
          this.loading = false
        })
    },

    closeDeal: function (id) {
      this.closeDealId = id;
      this.showModal('closeModalRef')
    },

    createPeriod: function (id, name = 'Dome deal', lastPeriod) {
      this.createPeriodFrom = this.getFirstDateToPeriod(lastPeriod.to);
      this.createPeriodTo = null;
      this.createPeriodDealId = id;
      this.createPeriodDealName = name;
      this.lastPeriodInfo = lastPeriod;
      this.showModal('createInvoicePeriodRef')
    },

    showModal(ref) {
      this.$refs[ref].show()
    },
    hideModal(ref) {
      this.closeDealId = false;
      this.createPeriodDealId = false;
      this.$refs[ref].hide()
    },

    doClose: async function () {
      let notification = {type: null, message: 'ok'};

      API.post(`/distribution/deals/${this.closeDealId}/close`).then(response => {
        if (response.status === 200) {
          notification = {type: 'success', message: 'Deal closed'};
        } else {
          notification = {type: 'warning', message: `Unable to close deal with status code ${response.status}`};
        }
      }).catch(e => {
        notification = {type: 'danger', message: `Unable to close deal with error ${e.message}`}
      }).finally(async () => {
        await this.loadData();
        this.hideModal('closeModalRef');
        this.$notifications.notify(
          {
            message: notification.message,
            icon: 'nc-icon nc-app',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: notification.type
          });
      });
    },
    doCreatePeriod: async function () {
      let notification = {type: null, message: 'ok'};
      const body = {
        from: this.createPeriodFrom,
        to: this.createPeriodTo
      }
      API.post(`/distribution/deals/${this.createPeriodDealId}/create-period`, body).then(response => {
        notification = {type: 'success', message: 'Period created'};
        this.$router.push(`/billing/${this.createPeriodDealId}`);

      }).catch(e => {
        let errorData = e.response.data
        let errors = errorData.map((item) => item.message)

        if (errors) {
          notification = {type: 'danger', message: errors.join(', ')}
        } else {
          notification = {type: 'danger', message: `Unable to create period ${e.message}`}
        }

      }).finally(async () => {
        await this.loadData();

        this.$notifications.notify(
          {
            message: notification.message,
            icon: 'nc-icon nc-app',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: notification.type
          });
      });
    },
    getFirstDateToPeriod(lastPeriodTo) {
      if (!lastPeriodTo) {
        return null;
      }
      const lastPeriod = new Date(lastPeriodTo),
        periodFrom = new Date(lastPeriod.setDate(lastPeriod.getDate() + 1)),
        year = periodFrom.getFullYear(),
        month = (periodFrom.getMonth()+1) < 10 ? '0'+(periodFrom.getMonth() + 1) : periodFrom.getMonth() + 1,
        date = periodFrom.getDate() < 10 ? '0'+periodFrom.getDate() : periodFrom.getDate()
      return `${year}-${month}-${date}`;
    }
  }
}
</script>
